import { User, Briefcase, Building2, Shield, MonitorSmartphone, Bell, SlidersHorizontal, Database, Sparkles, CreditCard, Plug, ArrowDownUp, AlertTriangle } from "lucide-react";

import { translateFr as tfr } from "@/i18n";
export const SETTINGS_SECTIONS = [
  { id: "account", label: "Compte", label_en: "Account", icon: User },
  { id: "profile-pro", label: "Profil professionnel", label_en: "Professional profile", icon: Briefcase, soon: true },
  { id: "team", label: tfr("Équipe & Workspace"), label_en: "Team & Workspace", icon: Building2 },
  { id: "security", label: tfr("Sécurité"), label_en: "Security", icon: Shield },
  { id: "sessions", label: "Sessions & appareils", label_en: "Sessions & devices", icon: MonitorSmartphone },
  { id: "notifications", label: "Notifications", label_en: "Notifications", icon: Bell, soon: true },
  { id: "preferences", label: tfr("Préférences"), label_en: "Preferences", icon: SlidersHorizontal },
  { id: "data", label: tfr("Données & confidentialité"), label_en: "Data & privacy", icon: Database },
  { id: "intelligence", label: "Athlynx Intelligence", label_en: "Athlynx Intelligence", icon: Sparkles, soon: true },
  { id: "billing", label: tfr("Abonnement & facturation"), label_en: "Subscription & billing", icon: CreditCard },
  { id: "integrations", label: tfr("Intégrations"), label_en: "Integrations", icon: Plug },
  { id: "import-export", label: "Import / Export", label_en: "Import / Export", icon: ArrowDownUp },
  { id: "danger", label: "Zone sensible", label_en: "Danger zone", icon: AlertTriangle, danger: true },
];

export const sectionLabel = (s) => {
  try { return localStorage.getItem("athlynx_lang") === "en" ? (s.label_en || s.label) : s.label; } catch { return s.label; }
};
